import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../axiosConfig";
import {
  formattedCurrentMonthData,
  startOfMonth,
  endOfMonth,
  currentDate,
  getCurrentMonthDatesAsia,
  getDatesFromMonthYearAsia,
  getUser,
} from "../helpers";
import { useModalContext } from "../ModalContext";

const CurrentMonthRowData = (type, user1, filters, currencyType) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [isFilterLoaded, setIsFilterLoaded] = useState(false);
  const user = getUser();
  const { currency } = useModalContext();
  // Track filter state change
  useEffect(() => {
    if (filters) {
      setIsFilterLoaded(true);
    }
  }, [filters]);

  useEffect(() => {
    const fetchData = () => {
      if (errorOccurred) return;
      if (!isFilterLoaded) return;

      setLoading(true);
      const apiEndpoint = filters
        ? "/api/summaryeditdetails"
        : "/datawithccnohierrachy";
      const requestPayload = filters
        ? {
            body: {
              ...filters,
              Date: "M",
              startdayofmonth: getDatesFromMonthYearAsia(filters.monthYear),
              user: user,
              currencyType: currencyType,
              page: "summary",
              type: type,
            },
          }
        : {
            Filters: false,
            Startdayofmonth: startOfMonth(),
            Enddateofmonth: endOfMonth(),
            Currentdate: currentDate(),
            type: type,
            user: user,
            currencyType: currencyType,
            page: "summary",
          };

      api
        .post(apiEndpoint, requestPayload)

        .then((response) => {
          const formattedData =
            response.data && formattedCurrentMonthData(response.data);
          setData(formattedData || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error fetching the data!", error);
          setError(error);
          setLoading(false);
          setErrorOccurred(true);
        });
    };

    fetchData();
  }, [type, errorOccurred, isFilterLoaded, currencyType]);

  return { loading, data, currency };
};

export default CurrentMonthRowData;
